import React, {useState} from 'react'
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import { homeObjOne, homeObjThree, homeObjTwo } from '../components/InfoSection/Data';
import Services from '../components/Services';

const Home = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Navbar toggle={toggle}/>
            <HeroSection></HeroSection>
            <InfoSection {...homeObjOne}></InfoSection>
            <InfoSection {...homeObjTwo}></InfoSection>
            <Services></Services>
            <InfoSection {...homeObjThree}></InfoSection>
            <Footer></Footer>
        </>
    )
}

export default Home
